'use client';
import { jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import { PopoverContentInternal } from '../popover/popover-content-internal.component.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useSwanPopover } from '../popover/popover.context.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
import { useIsomorphicLayoutEffect } from '../../hooks/use-isomorphic-layout-effect.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const ListboxPopover = renderWithRef('ListboxPopover', null, (n, a)=>{
    useDeprecatedProps('ListboxPopover', n, [
        {
            propName: 'labelText',
            instructions: 'This is deprecated without a replacement.'
        }
    ]);
    let { children: l, className: d, placement: u = 'bottom start', hideArrow: m = true, inModal: f } = n, b = _object_without_properties(n, [
        "children",
        "className",
        "placement",
        "hideArrow",
        "inModal"
    ]), { overlayState: h, triggerRef: w, fullWidth: y } = useSwanPopover(), _ = useRef(null), O = assignRefs(a, _), j = new Set([
        'swan-listbox-popover'
    ]);
    return d && j.add(d), useIsomorphicLayoutEffect(()=>{
        function handleResize() {
            let e = _.current, t = w.current;
            if (h.isOpen && y && t && e) {
                let { width: r } = t.getBoundingClientRect();
                e.style.width = `${r}px`, e.style.minWidth = `${r}px`, e.style.maxWidth = `${r}px`;
            }
        }
        if (handleResize(), 'object' == typeof window) return window.addEventListener('resize', handleResize), ()=>window.removeEventListener('resize', handleResize);
    }, [
        h.isOpen,
        y,
        w
    ]), h.isOpen ? jsx(RenderComp, {
        root: PopoverContentInternal,
        forwardedRef: O,
        classNames: j,
        props: _object_spread({
            placement: u,
            hideArrow: m,
            disableContainerPadding: true
        }, b),
        children: l
    }) : jsx("div", {
        "aria-hidden": "true",
        className: "swan-display-none",
        children: l
    });
});

export { ListboxPopover };
